import axios from "axios";
import API from "../helpers/api";

export const getClientShipCount = (clientId = null) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ClientShipCount}?mailId=${user.email}`;
  if (clientId) {
    url += `&clientId_=${clientId}`;
  }
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClientShipCountSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientShipCountFailure",
          error: "ERROR",
        });
      });
  };
};

export const getClientShipSearch = (searchItem, pageNo, clientId = null) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.ClientShipSearch}?Mail=${user.email}&ShipName=${searchItem.shipName}&PageNumber=${pageNo}&PageSize=${searchItem.pageSize}`;
  if (clientId) {
    url += `&clientId=${clientId}`;
  }
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getClientShipSearchSuccess",
          data: response.data,
        });
        dispatch({ type: "shipClientSuccess", data: searchItem });
      })
      .catch((error) => {
        dispatch({
          type: "getClientShipSearchFailure",
          error: "ERROR",
        });
      });
  };
};
